import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../../components/feature/Header';
import { BottomNav } from '../../components/feature/BottomNav';
import { WhatsAppFloat } from '../../components/feature/WhatsAppFloat';
import { Button } from '../../components/base/Button';
import { Card } from '../../components/base/Card';
import { SEOHead } from '../../components/seo/SEOHead';

export default function HomePage() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "CleanPro Services",
    "description": "Professional cleaning services for homes and offices. Quality guaranteed and competitive prices.",
    "url": siteUrl,
    "telephone": "9184078932",
    "email": "accesorios7g@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "US"
    },
    "priceRange": "$35-$200",
    "areaServed": {
      "@type": "Country",
      "name": "United States"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Cleaning Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Regular Home Cleaning",
            "description": "Weekly or bi-weekly cleaning of your home",
            "provider": {
              "@type": "LocalBusiness",
              "name": "CleanPro Services"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Deep Cleaning",
            "description": "Intensive cleaning ideal for moves or seasonal cleaning",
            "provider": {
              "@type": "LocalBusiness",
              "name": "CleanPro Services"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Office Cleaning",
            "description": "Daily or weekly maintenance of workspaces",
            "provider": {
              "@type": "LocalBusiness",
              "name": "CleanPro Services"
            }
          }
        }
      ]
    }
  };

  const categories = [
    { id: 'all', name: 'All', icon: 'ri-grid-line' },
    { id: 'residential', name: 'Residential', icon: 'ri-home-4-line' },
    { id: 'commercial', name: 'Commercial', icon: 'ri-building-line' },
    { id: 'specialized', name: 'Specialized', icon: 'ri-tools-line' }
  ];

  const services = [
    {
      id: 1,
      title: 'Regular Home Cleaning',
      category: 'residential',
      description:
        'Weekly or bi-weekly cleaning of your home. Includes vacuuming, mopping, bathroom and kitchen cleaning.',
      price: 120,
      duration: '2-3 hours',
      image:
        'https://public.readdy.ai/ai/img_res/da6b42c59ec6d302df4aa2ee1ab73a97.jpg',
      features: ['Complete vacuuming', 'Bathroom cleaning', 'Kitchen', 'Surfaces', 'Eco-friendly products']
    },
    {
      id: 2,
      title: 'Deep Cleaning',
      category: 'residential',
      description:
        'Intensive cleaning ideal for moves or seasonal cleaning. Includes hard-to-reach areas.',
      price: 180,
      duration: '4-6 hours',
      image:
        'https://readdy.ai/api/search-image?query=Deep%20cleaning%20service%20in%20progress%2C%20intensive%20house%20cleaning%20professional%20cleaner%20scrubbing%20surfaces%2C%20detailed%20cleaning%20work%20cleaning%20supplies%20and%20equipment%20thorough%20sanitization%20realistic%20photography%20style&width=300&height=200&seq=deep-clean&orientation=landscape',
      features: [
        'Window cleaning',
        'Inside appliances',
        'Baseboards',
        'Complete disinfection',
        'Eco-friendly products'
      ]
    },
    {
      id: 9,
      title: 'Garage Cleaning & Organization',
      category: 'specialized',
      description:
        'Deep cleaning and complete organization of garages. Includes item sorting and space optimization.',
      price: 150,
      duration: '4-5 hours',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20garage%20cleaning%20and%20organization%20service%2C%20organized%20garage%20with%20clean%20floors%20and%20sorted%20items%2C%20storage%20solutions%20and%20shelving%20systems%2C%20before%20and%20after%20transformation%2C%20realistic%20photography%20style%2C%20well-lit%20organized%20space&width=300&height=200&seq=garage-clean&orientation=landscape',
      features: ['Deep cleaning', 'Item organization', 'Tool sorting', 'Space optimization', 'Eco-friendly products']
    },
    {
      id: 3,
      title: 'Office Cleaning',
      category: 'commercial',
      description: 'Daily or weekly maintenance of workspaces. Clean and professional environment.',
      price: 150,
      duration: '1-2 hours',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20office%20cleaning%2C%20modern%20workplace%20being%20cleaned%2C%20desk%20sanitization%20commercial%20cleaning%20service%20office%20environment%20professional%20cleaner%20in%20uniform%20clean%20workspace%20business%20setting&width=300&height=200&seq=office-clean&orientation=landscape',
      features: ['Desks', 'Common areas', 'Bathrooms', 'Trash emptying', 'Eco-friendly products']
    },
    {
      id: 4,
      title: 'Post-Construction Cleaning',
      category: 'specialized',
      description:
        'Specialized cleaning after construction or renovations. Dust and debris removal.',
      price: 200,
      duration: '6-8 hours',
      image:
        'https://readdy.ai/api/search-image?query=Post%20construction%20cleaning%20service%2C%20cleaning%20after%20renovation%20work%2C%20removing%20construction%20dust%20and%20debris%2C%20professional%20cleaning%20team%20construction%20site%20cleanup%20specialized%20cleaning%20equipment%20realistic%20photography%20style&width=300&height=200&seq=post-construction&orientation=landscape',
      features: [
        'Dust removal',
        'Window cleaning',
        'Surface polishing',
        'Specialized vacuuming',
        'Eco-friendly products'
      ]
    },
    {
      id: 5,
      title: 'Window Cleaning',
      category: 'specialized',
      description:
        'Specialized window and glass cleaning service. Impeccable and streak-free results.',
      price: 35,
      duration: '1-2 hours',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20window%20cleaning%20service%2C%20cleaner%20washing%20large%20windows%20crystal%20clear%20glass%20surfaces%20squeegee%20and%20cleaning%20tools%20spotless%20window%20results%20natural%20lighting%20realistic%20photography%20style&width=300&height=200&seq=window-clean&orientation=landscape',
      features: ['Interior windows', 'Exterior windows', 'Mirrors', 'Glass doors', 'Eco-friendly products']
    },
    {
      id: 6,
      title: 'Commercial Space Cleaning',
      category: 'commercial',
      description:
        'Complete cleaning for stores, restaurants and other businesses. Professional maintenance.',
      price: 150,
      duration: '3-4 hours',
      image:
        'https://readdy.ai/api/search-image?query=Commercial%20space%20cleaning%2C%20retail%20store%20being%20cleaned%20professional%20cleaning%20of%20business%20premises%20clean%20and%20organized%20commercial%20environment%20cleaning%20team%20at%20work%20realistic%20photography%20style&width=300&height=200&seq=commercial-clean&orientation=landscape',
      features: ['Sales areas', 'Storage', 'Public restrooms', 'Main entrance', 'Eco-friendly products']
    },
    {
      id: 7,
      title: 'Move-in/Move-out Cleaning',
      category: 'specialized',
      description:
        'Complete cleaning for properties before or after moves. We leave the space spotless.',
      price: 200,
      duration: '4-5 hours',
      image:
        'https://readdy.ai/api/search-image?query=Moving%20cleaning%20service%2C%20empty%20house%20being%20cleaned%20after%20moving%20out%20professional%20cleaners%20preparing%20property%20for%20new%20tenants%20thorough%20cleaning%20of%20vacant%20home%20realistic%20photography%20style%20clean%20empty%20rooms&width=300&height=200&seq=moving-clean&orientation=landscape',
      features: [
        'Complete cleaning',
        'Total disinfection',
        'Cabinets and drawers',
        'Move-in ready prep',
        'Eco-friendly products'
      ]
    },
    {
      id: 8,
      title: 'Carpet Cleaning',
      category: 'specialized',
      description:
        'Deep carpet and rug cleaning. We remove stains, odors and dust mites with specialized equipment.',
      price: 35,
      duration: '2-3 hours',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20carpet%20cleaning%20service%2C%20steam%20cleaning%20machine%20on%20carpet%20deep%20carpet%20cleaning%20process%20removing%20stains%20and%20dirt%20from%20rugs%20specialized%20cleaning%20equipment%20realistic%20photography%20style%20fresh%20clean%20carpets&width=300&height=200&seq=carpet-clean&orientation=landscape',
      features: ['Steam cleaning', 'Stain removal', 'Deodorizing', 'Quick drying', 'Eco-friendly products']
    }
  ];

  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Guarantee',
      description: '100% satisfaction guaranteed'
    },
    {
      icon: 'ri-time-line',
      title: 'Punctuality',
      description: 'Always on time'
    },
    {
      icon: 'ri-team-line',
      title: 'Trained Staff',
      description: 'Experienced professionals'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Eco-Friendly Products',
      description: 'We care for the environment'
    }
  ];

  const filteredServices =
    selectedCategory === 'all'
      ? services
      : services.filter((service) => service.category === selectedCategory);

  // Simple placeholder image for broken URLs
  const placeholderImg = 'https://via.placeholder.com/300x200?text=Image+not+available';
  const handleImageError = (e) => {
    e.target.src = placeholderImg;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <SEOHead
        title="CleanPro Services - Professional Cleaning Services | Home & Office Cleaning"
        description="Professional cleaning services for homes and offices. Regular cleaning, deep cleaning, garage organization, post-construction, and more. Quality guaranteed with eco-friendly products."
        keywords="cleaning services, professional cleaning, home cleaning, office cleaning, deep cleaning, garage cleaning, post-construction cleaning, eco-friendly cleaning"
        schema={schema}
      />
      
      <Header />

      <main className="pt-20 pb-20">
        {/* Hero Section */}
        <section className="px-4 py-6">
          <div className="text-center mb-6">
            <h1 className="text-3xl font-bold text-gray-800 mb-3">
              Professional
              <span className="block text-blue-600">Cleaning Services</span>
            </h1>
            <p className="text-gray-600 mb-4 text-sm">
              We transform your space into a spotless and healthy place
            </p>
          </div>

          <div className="relative rounded-2xl overflow-hidden shadow-xl mb-6">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20cleaning%20team%20in%20action%2C%20modern%20home%20cleaning%20service%2C%20team%20of%20cleaners%20working%20together%2C%20bright%20and%20clean%20interior%20professional%20cleaning%20equipment%20realistic%20photography%20style%20high%20quality%20service%20satisfied%20customers&width=375&height=200&seq=hero-cleaning&orientation=landscape"
              alt="Professional cleaning services"
              className="w-full h-48 object-cover object-top"
              onError={handleImageError}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
          </div>
        </section>

        {/* Categories */}
        <section className="px-4 mb-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Our Services</h2>
          <div className="flex space-x-2 overflow-x-auto pb-2">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-full whitespace-nowrap transition-colors ${
                  selectedCategory === category.id
                    ? 'bg-blue-600 text-white'
                    : 'bg-white text-gray-600 border border-gray-200'
                }`}
              >
                <i className={`${category.icon} text-sm`}></i>
                <span className="text-sm font-medium">{category.name}</span>
              </button>
            ))}
          </div>
        </section>

        {/* Services Grid */}
        <section className="px-4 mb-8">
          <div className="space-y-4">
            {filteredServices.map((service) => (
              <Card key={service.id} className="overflow-hidden">
                <div className="relative mb-4">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-40 object-cover object-top rounded-xl"
                    onError={handleImageError}
                  />
                  <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                    <span className="text-blue-600 font-bold text-lg">${service.price}</span>
                  </div>
                </div>

                <div className="space-y-3">
                  <div>
                    <h3 className="font-bold text-gray-800 mb-1">{service.title}</h3>
                    <p className="text-gray-600 text-sm mb-2">{service.description}</p>
                    <div className="flex items-center text-gray-500 text-sm">
                      <i className="ri-time-line mr-1"></i>
                      <span>{service.duration}</span>
                    </div>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-700 text-sm mb-2">Includes:</h4>
                    <div className="grid grid-cols-2 gap-1">
                      {service.features.map((feature, index) => (
                        <div key={index} className="flex items-center text-sm text-gray-600">
                          <i className="ri-check-line text-green-500 mr-1 text-xs"></i>
                          <span className={feature === 'Eco-friendly products' ? 'text-green-600 font-medium' : ''}>
                            {feature}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex space-x-3 pt-2">
                    <Link to={`/reservar?service=${service.id}`} className="flex-1">
                      <Button fullWidth>
                        <div className="text-center">
                          <div className="flex items-center justify-center">
                            <i className="ri-calendar-line mr-2"></i>
                            Book Now
                          </div>
                          <div className="text-xs opacity-90 mt-1">
                            Pay after service
                          </div>
                        </div>
                      </Button>
                    </Link>
                    <Link to="/contacto">
                      <Button variant="outline" className="px-4">
                        <span className="text-green-600 font-medium text-sm">Quote</span>
                      </Button>
                    </Link>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </section>

        {/* Features Section */}
        <section className="px-4 py-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4 text-center">Why choose us?</h2>
          <div className="grid grid-cols-2 gap-4">
            {features.map((feature, index) => (
              <Card key={index} className="text-center">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className={`${feature.icon} text-blue-600 text-xl`}></i>
                </div>
                <h3 className="font-semibold text-gray-800 mb-2 text-sm">{feature.title}</h3>
                <p className="text-xs text-gray-600">{feature.description}</p>
              </Card>
            ))}
          </div>
        </section>

        {/* Payment Info Section */}
        <section className="px-4 py-6">
          <Card className="bg-gradient-to-br from-green-50 to-green-100 border-green-200">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">Pay when service is complete</h3>
              <p className="text-gray-600 text-sm">
                No need to pay now. Pay comfortably when we have finished your cleaning service.
              </p>
            </div>
          </Card>
        </section>

        {/* CTA Section */}
        <section className="px-4 py-6">
          <Card className="text-center bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200">
            <h2 className="text-xl font-bold text-gray-800 mb-3">Ready for a spotless space?</h2>
            <p className="text-gray-600 mb-6 text-sm">
              Book your cleaning service today and enjoy a clean and healthy environment
            </p>
            <Link to="/reservar">
              <Button size="lg" fullWidth>
                <i className="ri-sparkling-2-line mr-2"></i>
                Start Now
              </Button>
            </Link>
          </Card>
        </section>
      </main>

      <BottomNav />
      <WhatsAppFloat />
    </div>
  );
}
